import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { HeavenlyCultureCampaign } from "./types.ts";

export const getActiveCampaigns = defineQuery({
  input: z.object({}).optional(),
  handler: async ({ db }) => {
    const { data, error } = await db
      .from("heavenly_culture_campaign")
      .select("*")
      .eq("status", "published");
    if (error) throw error;
    return data as HeavenlyCultureCampaign[];
  },
});
